import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useController } from 'react-hook-form';

export const SPECIAL_OCCASION_OPTIONS = ['None', 'Birthday', 'Anniversary'];

function SpecialOccasionFormField() {
  const {
    field: { onChange, name, value, ref, onBlur }
  } = useController({
    name: 'specialOccasion'
  });

  return (
    <FormControl fullWidth>
      <InputLabel
        id="special-occasion"
        sx={theme => ({
          '&.MuiInputLabel-shrink': {
            backgroundColor: theme.palette.tofu.light,
            fontSize: '18px',
            paddingRight: '5px'
          }
        })}
      >
        Special Occasion
      </InputLabel>
      <Select
        labelId="special-occasion"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        name={name}
        label="Special Occasion"
        inputRef={ref}
        IconComponent={KeyboardArrowDownIcon}
      >
        {SPECIAL_OCCASION_OPTIONS.map(option => (
          <MenuItem value={option} key={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SpecialOccasionFormField;
